import { POST } from "../API"
let source;
export const reactToMessageForConversationApi = (reaction, conversationId, messageId, onSuccess, onError) => {
    const data = {
        reaction: reaction
    }
    source = POST(`/api/v1/chat/conversations/${conversationId}/messages/${messageId}`, data, onSuccess, onError, true, source)
}